import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { ToggleProps } from './ToggleProps';

export const Toggle: FunctionComponent<ToggleProps> = ({ isEnabled, onChange }) => {
  function toggle(): void {
    onChange(!isEnabled);
  }

  return (
    <div
      className={classNames(
        'relative w-10 p-0.5 inline-flex items-center rounded-full cursor-pointer transition-colors hover:bg-opacity-80',
        isEnabled ? 'bg-tint' : 'bg-gray-200'
      )}
      onClick={toggle}
    >
      <div
        className={classNames(
          'w-5 h-5 inline-block bg-white rounded-full shadow-sm transform pointer-events-none transition-transform',
          isEnabled ? 'translate-x-4' : 'translate-x-0'
        )}
      />
    </div>
  );
};
